import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ProjectsPage = lazy(() => import('./pages/ProjectsPage'));
const TasksPage = lazy(() => import('./pages/TasksPage'));
const DependenciesPage = lazy(() => import('./pages/DependenciesPage'));
const GanttPage = lazy(() => import('./pages/GanttPage'));

export const ManagementRoutes: RouteObject = {
  path: 'management',
  element: <ModuleGuard moduleId="projects.management" />,
  handle: { crumb: 'Management' },
  children: [
    { path: '', element: <Navigate to="projects" replace /> },
    { path: 'projects', element: <ProjectsPage />, handle: { crumb: 'Projects' } },
    { path: 'tasks', element: <TasksPage />, handle: { crumb: 'Tasks' } },
    { path: 'dependencies', element: <DependenciesPage />, handle: { crumb: 'Dependencies' } },
    { path: 'gantt', element: <GanttPage />, handle: { crumb: 'CPM Gantt' } },
  ],
};

export default ManagementRoutes;
